/**

 * Localise les libellés démo visibles selon la locale — BT-028-R1 / BT-028-R2.

 * @param {string} text

 * @param {'fr'|'en'} locale

 */

import { DEMO_TEXT_CATALOG_EN } from "@/i18n/demoTextCatalog.en.js";



export function localizeDemoText(text, locale = "fr") {

  if (!text || locale === "fr") return text;

  let out = String(text);

  if (DEMO_TEXT_CATALOG_EN[out]) {

    return DEMO_TEXT_CATALOG_EN[out];

  }

  for (const [fr, en] of Object.entries(DEMO_TEXT_CATALOG_EN)) {

    if (out.includes(fr)) {

      out = out.split(fr).join(en);

    }

  }

  return out

    .replace(/\[DÉMO\]/g, "[DEMO]")

    .replace(/Emplacement dojo/g, "Dojo location")

    .replace(/emplacement réservé/gi, "reserved placeholder")

    .replace(/à confirmer/gi, "to confirm")
    .replace(/À compléter/g, "To complete")
    .replace(/à compléter/gi, "to complete")

    .replace(/En attente assignation/gi, "Assignment pending")

    .replace(/Non assigné/gi, "Unassigned")

    .replace(/Données \[DÉMO\]/g, "[DEMO] data")

    .replace(/données démo/gi, "demo data")

    .replace(/compte assistant/gi, "assistant account")

    .replace(/Étudiant exemple/gi, "Sample student")

    .replace(/\[À VALIDER\]/gi, "[TO VALIDATE]")

    .replace(/(\d+)er dan/gi, (_, n) => `${n}${ordinalSuffixEn(Number(n))} dan`)

    .replace(/(\d+)e dan/gi, (_, n) => `${n}${ordinalSuffixEn(Number(n))} dan`)

    .replace(/Dojo général/g, "General dojo")

    .replace(/démo/gi, "demo");

}



/** Retire le préfixe [DÉMO]/[DEMO] pour afficher un seul badge visuel — BT-035. */
export function stripDemoPrefix(text) {
  if (!text) return "";
  return String(text).replace(/^\[(DÉMO|DEMO)\]\s*/i, "").trim();
}



/**
 * Libellé fichier import avec badge unique — BT-035.
 * @returns {{ text: string, showBadge: boolean }}
 */
export function formatImportFileDisplay(fichierNom, locale, isDemo = false) {
  const localized = localizeDemoText(fichierNom, locale) || "—";
  const hadPrefix = /^\[(DÉMO|DEMO)\]\s*/i.test(localized);
  const text = stripDemoPrefix(localized) || localized;
  return { text, showBadge: !!isDemo || hadPrefix };
}



function ordinalSuffixEn(n) {

  if (n === 1) return "st";

  if (n === 2) return "nd";

  if (n === 3) return "rd";

  return "th";

}



export function demoBadgeLabel(locale = "fr") {

  return locale === "en" ? "[DEMO]" : "[DÉMO]";

}



export function officialBadgeLabel(locale = "fr") {

  return locale === "en" ? "Official" : "Officiel";

}



/** Localise statut brut (clé ou libellé FR) pour affichage. */

export function localizeStatusKey(statut, locale = "fr") {

  if (!statut || locale === "fr") return statut;

  const map = {

    actif: "Active",

    inactif: "Inactive",

    a_confirmer: "To confirm",

    demo_a_valider: "demo_to_validate",

  };

  return map[statut] ?? statut;

}


